import React from 'react';

const WelcomeMessage = () => {
  return (
    <div className="mb-6">
      <h2 className="text-2xl font-semibold text-text-primary mb-2">Welcome Back</h2>
      <p className="text-text-secondary">
        Sign in to manage your epoxy flooring companies and visualizer configurations
      </p>
    </div>
  );
};

export default WelcomeMessage;